// Enterprise Model
export class Enterprise {
  constructor(data = {}) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.description = data.description || '';
    this.isActive = data.isActive !== undefined ? data.isActive : true;
    this.shortName = data.shortName || '';
    this.specialty = data.specialty || 'general';
    this.settings = data.settings || {};
    this.maxLicenses = data.maxLicenses || 0;
    this.usedLicenses = data.usedLicenses || 0;
    this.isAdmin = data.isAdmin || false;
    this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : new Date('2025-08-16T15:12:43.813Z');
    this.joinedAt = data.joinedAt ? new Date(data.joinedAt) : new Date('2025-08-16T15:12:50.628Z');
    this.licensingMode = data.licensingMode || 'none';
  }

  get availableLicenses() {
    return this.maxLicenses - this.usedLicenses;
  }

  get licenseUsagePercentage() {
    if (this.maxLicenses === 0) return 0;
    return Math.round((this.usedLicenses / this.maxLicenses) * 100);
  }

  get isAtCapacity() {
    return this.usedLicenses >= this.maxLicenses;
  }

  get isAutoLicensing() {
    return this.licensingMode === 'automated';
  }

  get isNoneLicensing() {
    return this.licensingMode === 'none';
  }
}

// Enterprise Admin Model
export class EnterpriseAdmin {
  constructor(data = {}) {
    this.id = data.id || '';
    this.email = data.email || '';
    this.firstName = data.firstName || '';
    this.lastName = data.lastName || '';
    this.fullName = data.fullName || `${this.firstName} ${this.lastName}`.trim();
  }
}
